/**
 * Ansichten-Tabs der Library (Redesign S2 Phase 2a, 2026-10-10) — vordefinierte
 * URL-Presets, KEINE gespeicherten Ansichten. Jeder Preset setzt/entfernt nur
 * Params, die das Backend schon versteht (`GET /api/assets` + `/stats`):
 *   - „Meine Uploads"  → `mine=1` (server-seitig auf den ctx-User aufgelöst)
 *   - „Freigabe offen" → `status=draft` (gleiche Datenquelle wie die
 *     Dashboard-Karte „Wartet auf Freigabe", DashboardPage `/library?status=draft`)
 *   - „Alle"           → beide Preset-Params raus
 * Alle übrigen Filter (Typ, Tags, Facetten, Suche) und die Präsentation bleiben
 * beim Tab-Wechsel erhalten — Tabs und Chips sind orthogonal.
 *
 * „Zuletzt hinzugefügt" fehlt bewusst: es gibt keinen Zeitfenster-Param
 * (`since`/`days`) im Query-Schema, und `sort=recent&dir=desc` ist bereits der
 * Default — der Tab zeigte exakt dieselbe Liste wie „Alle".
 */
import { parseStatus } from './parse-status';

export type LibraryView = 'all' | 'mine' | 'drafts';

export const LIBRARY_VIEWS: { id: LibraryView; label: string }[] = [
  { id: 'all', label: 'Alle' },
  { id: 'mine', label: 'Meine Uploads' },
  { id: 'drafts', label: 'Freigabe offen' },
];

/**
 * Welcher Preset entspricht der URL? `null`, wenn die Preset-Params in einer
 * Kombination stehen, die kein Tab erzeugt (z. B. `mine=1&status=draft` oder
 * `status=archived` über den Status-Chip) — dann ist kein Tab aktiv.
 */
export function activeLibraryView(params: URLSearchParams): LibraryView | null {
  const mine = params.get('mine') === '1';
  const status = parseStatus(params.get('status'));
  if (!mine && status === 'approved') return 'all';
  if (mine && status === 'approved') return 'mine';
  if (!mine && status === 'draft') return 'drafts';
  return null;
}

/** Wendet den Preset an; übrige Params bleiben (immutable, neues Objekt). */
export function applyLibraryView(prev: URLSearchParams, view: LibraryView): URLSearchParams {
  const next = new URLSearchParams(prev);
  next.delete('mine');
  next.delete('status');
  if (view === 'mine') next.set('mine', '1');
  if (view === 'drafts') next.set('status', 'draft');
  return next;
}
